<template>
    <div style="margin: 1rem">
        <div class="card appointment-card">
            <div class="left">Cita</div>
            <div class="right">
                <p>
                    <strong>Centro:</strong>
                    {{ clinicName }}
                </p>
                <p>
                    <strong>Cita:</strong>
                    {{ treatmentName }}
                </p>
                <p>
                    <strong>Fecha y Hora:</strong>
                    {{ formattedDate }} - {{ appointmentTime }}h
                </p>
            </div>
        </div>
        <div v-if="isLoading" class="loader-overlay">
            <div class="loader-container">
                <div class="spinner"></div>
                <p>Un momento por favor...</p>
            </div>
        </div>
        <div v-else>
            <div class="cita-header">
                <BackButton />
                <div class="titulo">Rellena tus datos</div>
            </div>
            <form @submit.prevent="submit">
                <label>
                    Nombre y Apellidos
                    <span class="required">*</span>
                    :
                </label>
                <input type="text" v-model="name" @blur="validateName" required />
                <span v-if="nameError" class="error-message">{{ nameError }}</span>
                <label>
                    Email
                    <span class="required">*</span>
                    :
                </label>
                <input type="email" v-model="email" @blur="validateEmail" required />
                <span v-if="emailError" class="error-message">{{ emailError }}</span>
                <label>
                    Teléfono
                    <span class="required">*</span>
                    :
                </label>
                <input type="tel" v-model="phone" @blur="validatePhone" required />
                <span v-if="phoneError" class="error-message">{{ phoneError }}</span>
                <label>Cuéntanos tu caso:</label>
                <textarea rows="3" v-model="observations"></textarea>
                <div class="privacy-policy">
                    <input type="checkbox" v-model="acceptPrivacyPolicy" required />
                    <label>
                        Acepto la
                        <a
                            href="https://www.clinicaferrusbratos.com/aviso-legal/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            política de privacidad
                        </a>
                        <span class="required">*</span>
                    </label>
                </div>
                <span v-if="privacyPolicyError" class="error-message">{{ privacyPolicyError }}</span>
                <button class="boton" type="submit">
                    Finalizar la reserva
                    <svg
                        class="arrow-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import BackButton from "@/components/BackButton.vue"; // Importa el botón de retroceso
import axios from "@/axios"; // Importa la instancia configurada

export default {
    components: {
        BackButton,
    },
    data() {
        return {
            name: "",
            email: "",
            phone: "",
            observations: "",
            acceptPrivacyPolicy: false,
            nameError: "", // Estado para el mensaje de error del nombre
            emailError: "", // Estado para el mensaje de error del email
            phoneError: "", // Estado para el mensaje de error del teléfono
            privacyPolicyError: "", // Estado para el mensaje de error de la política de privacidad
            isLoading: false, // Estado para el loader
        };
    },
    computed: {
        clinicName() {
            const clinics = {
                2: "Clínica Arturo Soria",
                3: "Clínica Velazquez",
                // Añadir más clínicas según sea necesario
            };
            return clinics[this.$store.state.clinic] || "Centro no seleccionado";
        },
        treatmentName() {
            const treatments = {
                implantes: "1ª - visita implantes / encías",
                ortodoncia: "1ª - visita ortodoncia",
                estetica: "1ª - visita estética",
                conservadora: "1ª - visita general",
                // Añadir más tratamientos según sea necesario
            };
            return treatments[this.$store.state.treatment] || "Tratamiento no seleccionado";
        },
        appointmentDate() {
            return this.$store.state.cita.fecha || "Fecha no seleccionada";
        },
        appointmentTime() {
            return this.$store.state.cita.fIniAux || "Hora no seleccionada";
        },
        formattedDate() {
            return this.formatDate(this.appointmentDate);
        },
    },
    methods: {
        formatDate(date) {
            if (!date) return "Fecha no seleccionada";
            const [year, month, day] = date.split("/");
            return `${day}/${month}/${year}`;
        },
        validateName() {
            const namePattern = /^[a-zA-ZÀ-ÿ]+(\s[a-zA-ZÀ-ÿ]+)+$/;
            if (!namePattern.test(this.name)) {
                this.nameError =
                    "El formato del nombre y apellidos no es válido. Por favor, revisa que has puesto al menos un apellido y que no contenga números o caracteres especiales (*,3,#)";
                return false;
            }
            this.nameError = "";
            return true;
        },
        validateEmail() {
            // eslint-disable-next-line
            const emailPattern = /^[^\s()<>@,;:\"\\[\]]+@[^\s()<>@,;:\"\\[\]]+\.[^\s()<>@,;:\"\\[\]]+$/;
            if (!emailPattern.test(this.email)) {
                this.emailError =
                    "El formato del email no es válido. Por favor, revisa que no contenga espacios, paréntesis, dos puntos...";
                return false;
            }
            this.emailError = "";
            return true;
        },
        validatePhone() {
            // El patrón E.164: permite un símbolo '+' opcional al inicio,
            // seguido de entre 2 y 15 dígitos (el primer dígito no puede ser 0).
            const phonePattern = /^\+?[1-9]\d{6,14}$/;
            if (!phonePattern.test(this.phone)) {
                this.phoneError =
                    "Por favor, introduce un número de teléfono internacional válido (formato E.164, ej.: +123456789)";
                return false;
            }
            this.phoneError = "";
            return true;
        },
        validatePrivacyPolicy() {
            if (!this.acceptPrivacyPolicy) {
                this.privacyPolicyError = "Debes aceptar la política de privacidad.";
                return false;
            }
            this.privacyPolicyError = "";
            return true;
        },
        getParamWeb(p) {
            var match = RegExp("[?&]" + p + "=([^&]*)").exec(window.location.search);
            return match && decodeURIComponent(match[1].replace(/\+/g, " "));
        },
        async submit() {
            this.isLoading = true;

            const isNameValid = this.validateName();
            const isEmailValid = this.validateEmail();
            const isPhoneValid = this.validatePhone();
            const isPrivacyPolicyValid = this.validatePrivacyPolicy();

            if (isNameValid && isEmailValid && isPhoneValid && isPrivacyPolicyValid) {
                const userInfo = {
                    name: this.name,
                    email: this.email,
                    phone: this.phone,
                    message: this.observations,
                    motivo: this.treatmentName,
                    tratamiento: this.treatmentName,
                    horainicio: null,
                    horafin: null,
                    url: window.location.href,
                    gaid: typeof window.gaid === "undefined" ? null : window.gaid,
                    gclid:
                        typeof window.gclid === "undefined" || window.gclid === "null"
                            ? this.getParamWeb("gclid")
                            : window.gclid,
                    utm_source:
                        typeof window.utm_source === "undefined" || window.utm_source === "null"
                            ? this.getParamWeb("utm_source")
                            : window.utm_source,
                    utm_medium:
                        typeof window.utm_medium === "undefined" || window.utm_medium === "null"
                            ? this.getParamWeb("utm_medium")
                            : window.utm_medium,
                    utm_campaign:
                        typeof window.utm_campaign === "undefined" || window.utm_campaign === "null"
                            ? this.getParamWeb("utm_campaign")
                            : window.utm_campaign,
                    utm_term:
                        typeof window.utm_term === "undefined" || window.utm_term === "null"
                            ? this.getParamWeb("utm_term")
                            : window.utm_term,
                    utm_content:
                        typeof window.utm_content === "undefined" || window.utm_content === "null"
                            ? this.getParamWeb("utm_content")
                            : window.utm_content,
                    idCentro: this.$store.state.clinic, // Asumiendo que idCentro se mapea desde clinic,
                    cita_online: this.$store.state.cita,
                };

                //Prueba LOCAL
                if (window.location.hostname === "192.168.4.206") {
                    this.$store.commit("setUserInfo", userInfo);
                    this.$router.push({ name: "Gracias" });
                }

                try {
                    const response = await axios.post("/save-user-info", userInfo);

                    if (response.data.success) {
                        this.isLoading = false;
                        this.$store.commit("setUserInfo", userInfo);
                        this.$router.push({ name: "Gracias" });
                    } else {
                        this.isLoading = false;
                        console.error("Error al guardar los datos:", response.data.message);
                        alert("Error al guardar los datos. Por favor, intenta nuevamente.");
                    }
                } catch (error) {
                    this.isLoading = false;
                    console.error("Error en la solicitud:", error);
                    alert("Ocurrió un error al enviar los datos. Por favor, intenta nuevamente.");
                }
            } else {
                this.isLoading = false;
                console.error("Error en la validación de los datos.");
                alert("Hay algún campo incorrecto. Por favor, revisa los datos e inténtalo de nuevo.");
            }
        },
    },
};
</script>

<style scoped>
form {
    display: flex;
    flex-direction: column;
    padding: 0 0.8rem;
    max-width: 500px;
    margin: 0 auto;
    gap: 0.2rem; /* Añadir espacio entre los elementos para reducir la altura */
}

label {
    margin: 5px 0; /* Reducir el margen superior e inferior */
    color: var(--blue-color);
    font-size: 0.9rem; /* Reducir el tamaño de la fuente */
}

input,
textarea {
    padding: 8px; /* Reducir el padding */
    margin-bottom: 1px; /* Reducir el margen inferior */
    border: 1px solid var(--blue-color); /* Color del borde */
    border-radius: 0.35rem; /* Añadir borde redondeado */
    color: var(--blue-color);
    line-height: normal;
    font-size: 15px;
}

.error-message {
    color: red;
    font-size: 15px;
    margin-bottom: 10px;
}

.boton {
    background-color: var(--pink-color);
    color: white;
    padding: 1.2rem;
    font-size: large;
    display: flex;
    justify-content: center;
    margin-top: 0.5rem;
}
.arrow-icon {
    width: 20px;
    height: 20px;
    margin-left: 10px;
}

.privacy-policy {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.privacy-policy input[type="checkbox"] {
    width: 20px; /* Aumentar el tamaño del checkbox */
    height: 20px; /* Aumentar el tamaño del checkbox */
}

.privacy-policy label {
    margin-left: 10px;
    font-size: 0.8rem; /* Reducir el tamaño de la fuente */
}

.privacy-policy a {
    color: var(--pink-color);
    text-decoration: underline;
}

.required {
    color: red;
}

.boton {
    background-color: var(--pink-color);
    color: white;
    padding: 1.2rem;
    font-size: large;
    display: flex;
    justify-content: center;
}
.arrow-icon {
    width: 20px;
    height: 20px;
    margin-left: 10px;
}

.appointment-card {
    border-radius: 8px;
    margin-bottom: 20px;
    font-size: 0.9rem;
    display: flex;
    margin: 0 auto;
}

@media (min-width: 768px) {
    .appointment-card {
        display: none !important;
    }
}

.appointment-card h4 {
    margin-top: 0;
    font-size: 1rem;
}

.appointment-card p {
    margin: 5px 0;
    font-size: 0.9rem;
    line-height: 1rem;
}
.appointment-card .left {
    background-color: var(--blue-color);
    color: white;
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    border-radius: 8px 0 0 8px;
}
.appointment-card .right {
    padding: 10px;
}
.card {
    display: flex;
    border-radius: 8px;
    max-width: 500px;
    cursor: pointer;
    transition: box-shadow 0.3s;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
    position: relative;
}

.card:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
}
.cita-header {
    display: flex;
    align-items: center;
    margin: 1.2rem 0.5rem 1rem;
}
.cita-header .titulo {
    font-size: 20px;
    font-weight: bold;
}

.loader-overlay {
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.loader-container {
    display: flex;
    padding: 2rem;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: var(--blue-color);
}

.loading-spinner {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0.4rem;
}
.loading-spinner .spinner {
    width: 10px;
    height: 10px;
}
.loading-spinner p {
    font-size: 0.7rem;
    margin: 0;
    text-align: center;
}
.spinner {
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top: 4px solid var(--pink-color);
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
